import { WS10DividerLineComponent } from '@vfde-fe/ngx-lib/brix/ws10-divider-line';
import { CheckboxComponent } from 'src/app/shared/shared-components/checkbox/checkbox.component';
import { RadioButtonComponent } from 'src/app/shared/shared-components/radio-button/radio-button.component';
import { SelectBlockComponent } from 'src/app/shared/shared-components/select-block/select-block.component';
import { TextInputBlockComponent } from 'src/app/shared/shared-components/text-input-block/text-input-block.component';
import { TextAreaBlockComponent } from 'src/app/shared/shared-components/text-area-block/text-area-block.component';
import { HeadlineComponent } from 'src/app/shared/shared-components/headline/headline.component';
import { ButtonLinkComponent } from 'src/app/shared/shared-components/button-link/button-link.component';
import { ParagraphComponent } from 'src/app/shared/shared-components/paragraph/paragraph.component';
import { UploadComponent } from 'src/app/shared/shared-components/upload/upload.component';
/** FIELD_TYPE_TEMPLATES maps each template key returned from the response to the component that needs to be loaded */
export const FIELD_TYPE_TEMPLATES = {
  'headline' : HeadlineComponent,
  'subheadline': HeadlineComponent,
  'input.text': TextInputBlockComponent,
  'input.email': TextInputBlockComponent,
  'input.date': TextInputBlockComponent,
  'input.time': TextInputBlockComponent,
  'input.number': TextInputBlockComponent,
  'textarea': TextAreaBlockComponent,
  'select': SelectBlockComponent,
  'checkbox': CheckboxComponent,
  'radiogroup': RadioButtonComponent,
  'download': ButtonLinkComponent,
  'separator': WS10DividerLineComponent,
  'paragraph': ParagraphComponent,
  'upload': UploadComponent,
};
